import { render, staticRenderFns } from "./combined-results.vue?vue&type=template&id=dd95bf2e&lang=pug"
import script from "./combined-results.vue?vue&type=script&lang=coffee"
export * from "./combined-results.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports